import { Enum, PATH } from '@/constants';
import { apiCaller } from '@/redux/query';
import { Banner, BannerTone, Link } from '@shopify/polaris';
import { useNavigate } from 'react-router-dom';
import RegularText from '../RegularText';
import { useSelector } from 'react-redux';
import { dataSettingsSelector } from '@/redux/slice/dataSettings.slice';
import { isSkipApiSelector } from '@/redux/slice/auth.slice';
import { useTranslation } from 'react-i18next';
interface Props {
  isHasLink?: boolean;
  onDismiss: () => void;
  mixpanelName?: any;
}

function BannerLimitRules({ isHasLink, onDismiss, mixpanelName }: Props) {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  const dataSettings = useSelector(dataSettingsSelector);
  const isSkip = useSelector(isSkipApiSelector);
  const maxLimitRules = dataSettings?.settings.user.numberRuleLimit || 0;
  const ruleBlockSummary = apiCaller.useRulesSummaryQuery(
    {
      type: Enum.ActionType.Block,
      priority: Enum.ListType.BlackList,
      criteria: Enum.CriteriaType.IpAddress,
    },
    { skip: isSkip },
  );
  const [trackAction] = apiCaller.useTrackActionMutation();

  return (
    <Banner
      title={(ruleBlockSummary?.data?.totalRulesActivated || 0) >= maxLimitRules ? t('free_plan_limit_reached') : ''}
      tone={
        (ruleBlockSummary?.data?.totalRulesActivated || 0) >= maxLimitRules
          ? (t('warning') as BannerTone)
          : (t('info') as BannerTone)
      }
      action={{
        content: ruleBlockSummary?.data?.totalRulesActivated === 0 ? t('see_pricing_plan') : t('increase_limit'),
        onAction: () => {
          navigate(PATH.PRICING_PLAN);
          trackAction('banner_limit_rule');
        },
      }}
      onDismiss={onDismiss}
    >
      {ruleBlockSummary?.data?.totalRulesActivated === 0 && ruleBlockSummary?.isLoading ? (
        <RegularText>
          {t('common:you_are_currently_in')} <b>{t('common:free_plan')}</b>. {t('common:upgrade_to_unlimited_access')}{' '}
          {isHasLink && <Link onClick={() => navigate(PATH.PRICING_PLAN)}>{t('common:learn_more')}</Link>}
        </RegularText>
      ) : (
        <RegularText>
          {(ruleBlockSummary?.data?.totalRulesActivated || 0) >= maxLimitRules ? (
            <>
              <b>{`${ruleBlockSummary?.data?.totalRulesActivated || 0}/${maxLimitRules}`}</b> {t('common:active_free_plan_rules')}{' '}
              {isHasLink && <Link onClick={() => navigate(PATH.PRICING_PLAN)}>{t('learn_more')}.</Link>}
            </>
          ) : (
            <>
              <b>{`${ruleBlockSummary?.data?.totalRulesActivated || 0}/${maxLimitRules}`}</b>{' '}
              {t('common:active_rules_limit_reached')}{' '}
              {isHasLink && <Link onClick={() => navigate(PATH.PRICING_PLAN)}>{t('learn_more')}.</Link>}
            </>
          )}
        </RegularText>
      )}
    </Banner>
  );
}

export default BannerLimitRules;
